import Vue from 'vue';
import App from './App.vue';
import './../node_modules/bulma/css/bulma.css';
import './../node_modules/bulma-calendar/dist/css/bulma-calendar.min.css';
import './../node_modules/bulma-calendar/dist/js/bulma-calendar.min.js';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
